import { StyledSurveyFooter } from './SurveyFooter.styled';
import { useTranslation } from 'react-i18next';

export const SurveyFooter = (): JSX.Element | null => {
    const { t } = useTranslation();

    const isIframe = window.self !== window.top;

    if (isIframe) {
        return null;
    }

    return (
        <StyledSurveyFooter>
            <a href={t('URLS.privacy')} target="_blank" rel="noreferrer">
                {t('Datenschutz')}
            </a>
            <a href={t('URLS.terms')} target="_blank" rel="noreferrer">
                {t('Impressum')}
            </a>
        </StyledSurveyFooter>
    );
};
